import { useEffect, useRef, useState } from "react";
import { Switch, message } from "antd";
import { useParams } from "react-router-dom";
import "./style.less";
import {
  useFetchAllBusinessUnitsQuery,
  useFetchJobGradesByCountryQuery,
  // useFetchAllJobFunctionsQuery,
  useFetchAllCompanyFunctionsQuery,
} from "@services";
import { useTypedSelector } from "@hooks";
import PermissionsTable from "../PermissionTable";
import {
  IBusinessUnitItem,
  ICountry,
  IJobFunctionItem,
  IJobGrade,
  IRegion,
} from "@types";
import Select from "react-select";

type RolePermissions = {
  [role: string]: string[];
};

const rolePermissions: RolePermissions = {
  COMPANY_SUPER_USER: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "UPDATE_BUSINESS_UNIT",
    "DELETE_BUSINESS_UNIT",
    "VIEW_REGION",
    "CREATE_REGION",
    "UPDATE_REGION",
    "DELETE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
    "UPDATE_COUNTRY",
    "DELETE_COUNTRY",
    "CREATE_TOM_USER",
    "VIEW_TOM_USER",
    "UPDATE_TOM_USER",
    "ENABLE_DISABLE_TOM_USER",
    "DELETE_TOM_USER",
    "CREATE_SECTOR",
    "VIEW_SECTOR",
    "UPDATE_SECTOR",
    "DELETE_SECTOR",
    "CREATE_INDUSTRY",
    "VIEW_INDUSTRY",
    "UPDATE_INDUSTRY",
    "DELETE_INDUSTRY",
    "CREATE_SUB_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "UPDATE_SUB_INDUSTRY",
    "DELETE_SUB_INDUSTRY",
    "CREATE_JOB_FUNCTION",
    "VIEW_JOB_FUNCTION",
    "UPDATE_JOB_FUNCTION",
    "DELETE_JOB_FUNCTION",
    "CREATE_JOB_SUB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "UPDATE_JOB_SUB_FUNCTION",
    "DELETE_JOB_SUB_FUNCTION",
    "CREATE_COMPANY",
    "VIEW_COMPANY",
    "UPDATE_COMPANY",
    "ENABLE_DISABLE_COMPANY",
    "DELETE_COMPANY",
    "CREATE_LEGAL_ENTITY",
    "VIEW_LEGAL_ENTITY",
    "UPDATE_LEGAL_ENTITY",
    "DELETE_LEGAL_ENTITY",
    "CREATE_GRADE_COMPANY_MAPPING",
    "VIEW_GRADE_COMPANY_MAPPING",
    "UPDATE_GRADE_COMPANY_MAPPING",
    "DELETE_GRADE_COMPANY_MAPPING",
    "CREATE_COMPANY_USER",
    "VIEW_COMPANY_USER",
    "UPDATE_COMPANY_USER",
    "ENABLE_DISABLE_COMPANY_USER",
    "DELETE_COMPANY_USER",
    "CREATE_OFFER",
    "VIEW_OFFER",
    "UPDATE_OFFER",
    "DELETE_OFFER",
    "CREATE_JOB_GRADE",
    "VIEW_JOB_GRADE",
    "UPDATE_JOB_GRADE",
    "DELETE_JOB_GRADE",
    "CREATE_SALARY_RANGE",
    "VIEW_SALARY_RANGE",
    "UPDATE_SALARY_RANGE",
    "DELETE_SALARY_RANGE",
    "CREATE_CASH_ALLOWANCE",
    "VIEW_CASH_ALLOWANCE",
    "UPDATE_CASH_ALLOWANCE",
    "DELETE_CASH_ALLOWANCE",
    "CREATE_COMPANY_STI",
    "VIEW_COMPANY_STI",
    "UPDATE_COMPANY_STI",
    "DELETE_COMPANY_STI",
    "CREATE_COMPANY_LTI",
    "VIEW_COMPANY_LTI",
    "UPDATE_COMPANY_LTI",
    "DELETE_COMPANY_LTI",
    "CREATE_INTERNAL_PAYROLL",
    "VIEW_INTERNAL_PAYROLL",
    "UPDATE_INTERNAL_PAYROLL",
    "DELETE_INTERNAL_PAYROLL",
    "CREATE_MARKET_DATA",
    "VIEW_MARKET_DATA",
    "UPDATE_MARKET_DATA",
    "DELETE_MARKET_DATA",
    "CREATE_JOB_EVALUATION",
    "VIEW_JOB_EVALUATION",
    "UPDATE_JOB_EVALUATION",
    // add new roles for tom benefit module
    "CREATE_BENEFITS_PLAN",
    "VIEW_BENEFITS_PLAN",
    "UPDATE_BENEFITS_PLAN",
    "DELETE_BENEFITS_PLAN",
  ],

  COMPANY_ADMIN: [
    "VIEW_SECTOR",
    "VIEW_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COMPANY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_COUNTRY",
    "VIEW_LEGAL_ENTITY",
    "VIEW_COMPANY_USER",
    "CREATE_BUSINESS_UNIT",
    "CREATE_REGION",
    "CREATE_COUNTRY",
    "CREATE_OFFER",
    "VIEW_OFFER",
    "UPDATE_OFFER",
    "CREATE_JOB_GRADE",
    "VIEW_JOB_GRADE",
    "UPDATE_JOB_GRADE",
    "CREATE_SALARY_RANGE",
    "VIEW_SALARY_RANGE",
    "UPDATE_SALARY_RANGE",
    "CREATE_CASH_ALLOWANCE",
    "VIEW_CASH_ALLOWANCE",
    "UPDATE_CASH_ALLOWANCE",
    "CREATE_COMPANY_STI",
    "VIEW_COMPANY_STI",
    "UPDATE_COMPANY_STI",
    "CREATE_COMPANY_LTI",
    "VIEW_COMPANY_LTI",
    "UPDATE_COMPANY_LTI",
    "CREATE_INTERNAL_PAYROLL",
    "VIEW_INTERNAL_PAYROLL",
    "UPDATE_INTERNAL_PAYROLL",
    "CREATE_MARKET_DATA",
    "VIEW_MARKET_DATA",
    "UPDATE_MARKET_DATA",
    "VIEW_TOM_DASHBOARD",
    // add new roles for tom benefit module
    "CREATE_BENEFITS_PLAN",
    "VIEW_BENEFITS_PLAN",
    "UPDATE_BENEFITS_PLAN",
  ],

  COMPANY_USER: [
    "VIEW_CASH_ALLOWANCE",
    "VIEW_COMPANY_STI",
    "VIEW_SECTOR",
    "VIEW_COMPANY_LTI",
    "VIEW_INDUSTRY",
    "VIEW_INTERNAL_PAYROLL",
    "VIEW_SUB_INDUSTRY",
    "VIEW_MARKET_DATA",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COUNTRY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_LEGAL_ENTITY",
    "CREATE_OFFER",
    "VIEW_OFFER",
    "UPDATE_OFFER",
    "VIEW_JOB_GRADE",
    "VIEW_SALARY_RANGE",
    "VIEW_COMPANY",
    "VIEW_COMPANY_USER",
    "VIEW_TOM_DASHBOARD",
    // add new roles for tom benefit module
    "VIEW_BENEFITS_PLAN",
  ],

  COMPANY_BUSINESS_ACCESS: [
    "VIEW_SECTOR",
    "VIEW_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COMPANY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_COUNTRY",
    "VIEW_LEGAL_ENTITY",
    "VIEW_COMPANY_USER",
    "VIEW_OFFER",
    "VIEW_JOB_GRADE",
    "VIEW_SALARY_RANGE",
    "VIEW_CASH_ALLOWANCE",
    "VIEW_COMPANY_STI",
    "VIEW_COMPANY_LTI",
    "VIEW_INTERNAL_PAYROLL",
    "VIEW_MARKET_DATA",
    "VIEW_TOM_DASHBOARD",
    // add new roles for tom benefit module
    "VIEW_BENEFITS_PLAN",
  ],
};

const TomTab = ({
  TomData,
  selected_user,
  createDataCallback,
}: {
  TomData: any;
  selected_user: any;
  createDataCallback: (key: string, data: any) => void;
}) => {
  const { user } = useTypedSelector(state => state.auth);

  const [businessUnitState, setBusinessUnitState] = useState<any[]>([]);
  const [regionState, setRegionState] = useState<any[]>([]);
  const countriesRef = useRef<any>(null);
  const gradesRef = useRef<any>(null);
  const jobFunctionsRef = useRef<any>(null);
  const [regions, setRegions] = useState<Partial<IRegion>[]>([]);
  const [countryState, setCountryState] = useState<any[]>([]);
  const [countries_id, setCountryIdState] = useState<any[]>([]);
  const [countries, setCountries] = useState<any[]>([]);
  const [grade, setGrade] = useState<any[]>([]);
  const [jobFunctionState, setJobFunctionState] = useState<any[]>([]);
  const [role, setRole] = useState<string>("");
  const [isCustomRole, setIsCustomRole] = useState<boolean>(false);
  const [permissionArray, setPermissionArray] = useState<string[]>([]);
  const [setData, setSetData] = useState<boolean>(false);
  const [permissionAPIArray, setPermissionAPIArray] = useState<string[]>([]);
  const [accessGranted, setAccessGranted] = useState<boolean>(false);
  const [TOMDashboard, setTOMDashboard] = useState<boolean>(false);
  const [isLivePayTool, setIsLivePayTool] = useState<boolean>(false);

  const [validationErrors, setValidationErrors] = useState({
    businessUnits: "",
    regions: "",
    countries: "",
    grades: "",
    jobFunctions: "",
    role: "",
  });

  const params: { company_id: string } = useParams();
  const paramsCompanyId = params.company_id;
  const { id: company_id } = user?.company || { id: paramsCompanyId };

  const { data: businessUnitsData } = useFetchAllBusinessUnitsQuery({
    company_id,
  });
  const { data: businessUnits } = businessUnitsData || {};
  const { data: gradesData, refetch } = useFetchJobGradesByCountryQuery(
    { company_id, countries_id },
    { refetchOnMountOrArgChange: true }
  );
  const { data: grades } = gradesData || {};
  // const { data: jobFunctionsData } = useFetchAllJobFunctionsQuery(null);
  // const { data: jobFunctions } = jobFunctionsData || {};

  const { data: companyJobFunctionsData } = useFetchAllCompanyFunctionsQuery({
    company_id,
  });
  const { data: jobFunctions } = companyJobFunctionsData || {};

  // Load initial TOM data
  useEffect(() => {
    if (!TomData || !businessUnits?.length) return;

    setAccessGranted(TomData?.grant_access ?? false);
    setIsLivePayTool(TomData?.role_metafield?.has_live_pay_tool ?? false);
    setTOMDashboard(
      TomData?.name === "COMPANY_SUPER_USER"
        ? true
        : TomData?.permissions?.includes("VIEW_TOM_DASHBOARD") || false
    );

    const apiBusiness = TomData?.metafield?.business_units || [];
    setBusinessUnitState(apiBusiness);

    const extractRegionsFromBU = businessUnits.filter((elm: any) =>
      apiBusiness.includes(elm.id)
    );
    let tempRegions: any[] = [];
    extractRegionsFromBU.forEach((elm: any) => {
      tempRegions.push(...(elm.regions || []));
    });
    const distinctRegionsArr = Object.values(
      tempRegions.reduce((acc: any, r: any) => {
        if (!acc[r.id]) acc[r.id] = r;
        return acc;
      }, {})
    ) as Partial<IRegion>[];
    setRegions(distinctRegionsArr);

    setRegionState(TomData?.metafield?.regions || []);

    let tempCountries: any[] = [];
    distinctRegionsArr
      .filter((region: any) =>
        (TomData?.metafield?.regions || []).includes(region.id)
      )
      .forEach((region: any) => {
        tempCountries.push(...(region.countries || []));
      });

    const distinctCountriesArr = Object.values(
      tempCountries.reduce((acc: any, c: any) => {
        if (!acc[c.id]) acc[c.id] = c;
        return acc;
      }, {})
    );

    setCountries(distinctCountriesArr);
    setCountryState(TomData?.metafield?.countries || []);
    setGrade(TomData?.metafield?.grades || []);
    // setJobFunctionState(TomData?.metafield?.job_functions || []);
    setJobFunctionState(TomData?.metafield?.company_job_functions || []);
    setPermissionArray(TomData?.permissions || []);
    setPermissionAPIArray(TomData?.permissions || []);
    setRole(TomData?.name || "");
    setIsCustomRole(TomData?.name !== "COMPANY_SUPER_USER");
  }, [TomData, businessUnits]);

  // Validation logic
  const isAllRequired =
    accessGranted ||
    (accessGranted && TOMDashboard && isLivePayTool) ||
    (accessGranted && TOMDashboard && !isLivePayTool) ||
    (accessGranted && isLivePayTool && !TOMDashboard) ||
    (!accessGranted && TOMDashboard && isLivePayTool);

  const isLimitedRequired = !accessGranted && !TOMDashboard && isLivePayTool;

  const isGradesDisabled = isLimitedRequired;
  const isJobFunctionsDisabled = isLimitedRequired;
  const isRoleDisabled = isLimitedRequired;
  const isSuperUser = role === "COMPANY_SUPER_USER";

  const validateTomFields = (): boolean => {
    const errors: any = {};

    // Skip validation for COMPANY_SUPER_USER since fields are disabled
    const skipValidationRoles = ["COMPANY_SUPER_USER"];
    if (skipValidationRoles.includes(role)) {
      setValidationErrors({
        businessUnits: "",
        regions: "",
        countries: "",
        grades: "",
        jobFunctions: "",
        role: "",
      });
      return true;
    }

    if (
      isAllRequired ||
      isLimitedRequired ||
      accessGranted ||
      TOMDashboard ||
      isLivePayTool
    ) {
      if (!businessUnitState?.length)
        errors.businessUnits = "Please select at least one Business Unit";
      if (!regionState?.length)
        errors.regions = "Please select at least one Region";
      if (!countryState?.length)
        errors.countries = "Please select at least one Country";
    }

    if (isAllRequired) {
      if (!grade?.length) errors.grades = "Please select at least one Grade";
      if (!jobFunctionState?.length)
        errors.jobFunctions = "Please select at least one Job Function";
      if (!role?.trim()) errors.role = "Please define a Role name";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    createDataCallback("tom_validation", validateTomFields);
  }, [
    accessGranted,
    TOMDashboard,
    isLivePayTool,
    businessUnitState,
    regionState,
    countryState,
    grade,
    jobFunctionState,
    role,
  ]);

  useEffect(() => {
    if (setData) {
      handleCreateData();
      setSetData(false);
    }
  }, [setData]);

  const handleCreateData = () => {
    let data = {
      grant_access: accessGranted,
      name: role,
      description: role,
      metafield: {
        business_units: businessUnitState,
        regions: regionState,
        countries: countryState,
        grades: grade,
        // job_functions: jobFunctionState,
        company_job_functions: jobFunctionState,
      },
      role_metafield: {
        has_live_pay_tool: isLivePayTool,
      },
      permissions: permissionArray,
    };
    createDataCallback("tom", data);
  };

  // Toggles
  const changeGrantedAccess = () => {
    setAccessGranted(!accessGranted);
    setSetData(true);
  };

  const changeTOMDashboard = () => {
    const newTOMDashboard = !TOMDashboard;
    setTOMDashboard(newTOMDashboard);
    if (newTOMDashboard) {
      if (!permissionArray.includes("VIEW_TOM_DASHBOARD")) {
        setPermissionArray([...permissionArray, "VIEW_TOM_DASHBOARD"]);
      }
    } else {
      setPermissionArray(
        permissionArray.filter(perm => perm !== "VIEW_TOM_DASHBOARD")
      );
    }
    setSetData(true);
  };

  const changeBenchMarkingTool = () => {
    setIsLivePayTool(!isLivePayTool);
    setSetData(true);
  };

  // Default roles
  const allRoles = [
    { label: "COMPANY_SUPER_USER", value: "COMPANY_SUPER_USER" },
    { label: "COMPANY_ADMIN", value: "COMPANY_ADMIN" },
    { label: "COMPANY_USER", value: "COMPANY_USER" },
    { label: "COMPANY_BUSINESS_ACCESS", value: "COMPANY_BUSINESS_ACCESS" },
  ];

  const getPermissionsForRole = (role: string): string[] => {
    return rolePermissions[role] || [];
  };

  return (
    <>
      <div className="sub__admin_details_container">
        <div style={{ padding: "32px 20px 12px", display: "flex" }}>
          <div
            style={{
              backgroundColor: "#FAFAFA",
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            <span style={{ fontWeight: 500, marginRight: "16px" }}>
              Grant Access
            </span>
            <Switch checked={accessGranted} onChange={changeGrantedAccess} />
          </div>

          {user?.company?.applications?.findIndex(
            elm => elm?.enum === "LIVE_PAY_BENCHMARKING_TOOL"
          ) !== -1 && (
            <div
              style={{
                backgroundColor: "#FAFAFA",
                padding: "16px",
                borderRadius: "8px",
                marginLeft: "32px",
              }}
            >
              <span style={{ fontWeight: 500, marginRight: "16px" }}>
                Bench Marking Tool
              </span>
              <Switch
                checked={isLivePayTool}
                onChange={changeBenchMarkingTool}
              />
            </div>
          )}

          <div
            style={{
              backgroundColor: "#FAFAFA",
              padding: "16px",
              borderRadius: "8px",
              marginLeft: "32px",
            }}
          >
            <span style={{ fontWeight: 500, marginRight: "16px" }}>
              TOM Dashboard
            </span>
            <Switch
              disabled={TomData?.name === "COMPANY_SUPER_USER"}
              checked={TOMDashboard}
              onChange={changeTOMDashboard}
            />
          </div>
        </div>

        {/* Role and form fields */}
        <div className="form__section">
          <div className="form__section_container grid grid-cols-2 gap-10">
            {/* Business Units */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Business Units</label>
              <Select
                isMulti
                placeholder="Search Business Units"
                isDisabled={isSuperUser}
                value={businessUnits
                  ?.filter((b: any) => businessUnitState.includes(b.id))
                  ?.map((b: any) => ({ label: b.name, value: b.id }))}
                options={[
                  { label: "All", value: "all" },
                  ...(businessUnits?.map((b: any) => ({
                    label: b.name,
                    value: b.id,
                  })) || []),
                ]}
                onChange={(val: any) => {
                  let selectedBUs: any[] = [];

                  // Check if "All" is selected
                  if (val.some((v: any) => v.value === "all")) {
                    // If "All" is being selected, select all business units
                    selectedBUs = businessUnits?.map((b: any) => b.id) || [];
                  } else {
                    // Otherwise, use the selected values
                    selectedBUs = val.map((v: any) => v.value);
                  }

                  setBusinessUnitState(selectedBUs);

                  // Clear dependent fields
                  setRegionState([]);
                  setCountryState([]);
                  setCountryIdState([]);
                  setGrade([]);
                  setJobFunctionState([]);

                  // Clear validation errors related to dependent fields
                  setValidationErrors(prev => ({
                    ...prev,
                    businessUnits: "",
                  }));

                  setSetData(true);
                }}
              />
              {validationErrors.businessUnits && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.businessUnits}
                </p>
              )}
            </div>

            {/* Region */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Region</label>
              <Select
                isMulti
                isDisabled={isSuperUser || !businessUnitState?.length}
                placeholder="Search Region"
                value={regions
                  ?.filter((r: any) => regionState.includes(r.id))
                  ?.map((r: any) => ({ label: r.name, value: r.id }))}
                options={[
                  { label: "All", value: "all" },
                  ...(regions?.map((r: any) => ({
                    label: r.name,
                    value: r.id,
                  })) || []),
                ]}
                onChange={(val: any) => {
                  let selectedRegions: any[] = [];

                  // Check if "All" is selected
                  if (val.some((v: any) => v.value === "all")) {
                    // If "All" is being selected, select all regions
                    selectedRegions = regions?.map((r: any) => r.id) || [];
                  } else {
                    // Otherwise, use the selected values
                    selectedRegions = val.map((v: any) => v.value);
                  }

                  setRegionState(selectedRegions);

                  // Clear dependent fields
                  setCountryState([]);
                  setCountryIdState([]);
                  setGrade([]);
                  setJobFunctionState([]);

                  // Clear related validation errors
                  setValidationErrors(prev => ({
                    ...prev,
                    regions: "",
                  }));

                  setSetData(true);
                }}
              />
              {validationErrors.regions && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.regions}
                </p>
              )}
            </div>

            {/* Country */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Country</label>
              <Select
                isMulti
                isDisabled={!regionState?.length}
                closeMenuOnSelect={false} // keeps dropdown open after selecting
                placeholder="Search Country"
                value={countries
                  ?.filter((c: any) => countryState.includes(c.id))
                  ?.map((c: any) => ({ label: c.name, value: c.id }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(countries?.map((c: any) => ({
                    label: c.name,
                    value: c.id,
                  })) || []),
                ]}
                ref={countriesRef}
                onChange={(val: any) => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    // Toggle behavior: if ALL was already selected, clear all
                    const allIds = countries?.map((c: any) => c.id) || [];
                    const alreadyAllSelected =
                      countryState.length === allIds.length;

                    const selectedCountries = alreadyAllSelected ? [] : allIds;

                    setCountryState(selectedCountries);
                    setCountryIdState(selectedCountries);
                    countriesRef.current?.blur();
                  } else {
                    // Only selected countries
                    const selectedCountries = val.map((v: any) => v.value);
                    setCountryState(selectedCountries);
                    setCountryIdState(selectedCountries);
                  }

                  // Clear dependent fields
                  setGrade([]);
                  setJobFunctionState([]);

                  // Clear related validation errors
                  setValidationErrors(prev => ({
                    ...prev,
                    countries: "",
                  }));

                  setSetData(true);
                }}
              />

              {validationErrors.countries && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.countries}
                </p>
              )}
            </div>

            {/* Grades */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Grades</label>
              <Select
                isMulti
                closeMenuOnSelect={false} // keeps dropdown open after selecting
                isDisabled={isSuperUser || !countryState?.length}
                placeholder="Select Grades"
                ref={gradesRef}
                value={grades
                  ?.filter((g: any) => grade.includes(g.id))
                  ?.map((g: any) => ({ label: g.grade, value: g.id }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(grades?.map((g: any) => ({
                    label: g.grade,
                    value: g.id,
                  })) || []),
                ]}
                onChange={(val: any) => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    // Toggle behavior: if ALL was already selected, clear all
                    const allIds = grades?.map((g: any) => g.id) || [];
                    const alreadyAllSelected = grade.length === allIds.length;

                    const selectedGrades = alreadyAllSelected ? [] : allIds;
                    setGrade(selectedGrades);
                    gradesRef.current?.blur();
                  } else {
                    // Only selected grades
                    const selectedGrades = val.map((v: any) => v.value);
                    setGrade(selectedGrades);
                  }

                  // Clear validation
                  setValidationErrors(prev => ({
                    ...prev,
                    grades: "",
                  }));

                  setSetData(true);
                }}
              />

              {validationErrors.grades && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.grades}
                </p>
              )}
            </div>

            {/* Job Functions */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Company Job Functions</label>
              {/* <Select
                isMulti
                isDisabled={isSuperUser || isJobFunctionsDisabled}
                placeholder="Select Job Functions"
                value={jobFunctions
                  ?.filter((j: any) => jobFunctionState.includes(j.id))
                  ?.map((j: any) => ({ label: j.name, value: j.id }))}
                options={jobFunctions?.map((j: any) => ({
                  label: j.name,
                  value: j.id,
                }))}
                onChange={(val: any) => {
                  setJobFunctionState(val.map((v: any) => v.value));
                  setValidationErrors(prev => ({
                    ...prev,
                    jobFunctions: "",
                  }));
                  setSetData(true);
                }}
              /> */}
              <Select
                isMulti
                closeMenuOnSelect={false} // keeps dropdown open after selecting
                isDisabled={isSuperUser || isJobFunctionsDisabled}
                placeholder="Select Job Functions"
                value={jobFunctions
                  ?.filter((j: any) => jobFunctionState.includes(j.id))
                  ?.map((j: any) => ({ label: j.name, value: j.id }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(jobFunctions?.map((j: any) => ({
                    label: j.name,
                    value: j.id,
                  })) || []),
                ]}
                ref={jobFunctionsRef}
                onChange={(val: any) => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    // Toggle behavior: if ALL was already selected, clear all
                    const allIds = jobFunctions?.map((j: any) => j.id) || [];
                    const alreadyAllSelected =
                      jobFunctionState.length === allIds.length;

                    const selectedJobFunctions = alreadyAllSelected
                      ? []
                      : allIds;
                    setJobFunctionState(selectedJobFunctions);
                    jobFunctionsRef.current?.blur();
                  } else {
                    // Only selected job functions
                    const selectedJobFunctions = val.map((v: any) => v.value);
                    setJobFunctionState(selectedJobFunctions);
                  }

                  // Clear validation
                  setValidationErrors(prev => ({
                    ...prev,
                    jobFunctions: "",
                  }));

                  setSetData(true);
                }}
              />

              {validationErrors.jobFunctions && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.jobFunctions}
                </p>
              )}
            </div>
            {/* Role */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Role</label>
              {!isCustomRole ? (
                <Select
                  placeholder="Select role from here..."
                  components={{ IndicatorSeparator: () => null }}
                  value={allRoles.find(elm => role === elm.value) || null}
                  onChange={(newValue: any) => {
                    const selectedRole = newValue?.value;
                    setRole(selectedRole);
                    const permissions = getPermissionsForRole(selectedRole);
                    setPermissionAPIArray(permissions);
                    setPermissionArray(permissions);

                    // If COMPANY_SUPER_USER selected, clear other fields
                    if (selectedRole === "COMPANY_SUPER_USER") {
                      setBusinessUnitState([]);
                      setRegionState([]);
                      setCountryState([]);
                      setGrade([]);
                      setJobFunctionState([]);
                    }

                    setValidationErrors(prev => ({
                      ...prev,
                      role: "",
                    }));

                    setSetData(true);
                  }}
                  options={allRoles}
                  isDisabled={user?.id === selected_user?.id || isRoleDisabled}
                />
              ) : (
                <input
                  style={{
                    border: "0.75px solid #d9d9d9",
                    padding: "0.5rem 11px",
                    borderRadius: "2px",
                  }}
                  name="role"
                  type="text"
                  placeholder="Enter custom role here..."
                  value={role}
                  onChange={e => {
                    setRole(e.target.value);
                    setValidationErrors(prev => ({
                      ...prev,
                      role: "",
                    }));
                    setSetData(true);
                  }}
                  disabled={user?.id === selected_user?.id || isRoleDisabled}
                />
              )}

              {validationErrors.role && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.role}
                </p>
              )}

              {user?.id !== selected_user?.id && (
                <>
                  {!isCustomRole ? (
                    <div
                      className="change_role"
                      onClick={() => {
                        setIsCustomRole(true);
                        setRole("");
                      }}
                    >
                      Create custom role
                    </div>
                  ) : (
                    user?.id !== selected_user?.id && (
                      <div
                        className="change_role"
                        onClick={() => {
                          setIsCustomRole(false);
                          setRole("");
                        }}
                      >
                        Select from default roles
                      </div>
                    )
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Permissions Table */}
      <div className="sub__admin_details_container">
        <h1 className="section__heading margin__bottom__0">
          Permission Settings
        </h1>
        <div className="form__section mb-5">
          <PermissionsTable
            hideJe={true}
            role={role === "COMPANY_SUPER_USER"}
            setCallback={(val: any) => {
              setPermissionArray(val);
              setSetData(true);
            }}
            permissionAPIArray={
              permissionArray?.length > 0 ? permissionArray : permissionAPIArray
            }
          />
        </div>
      </div>
    </>
  );
};

export default TomTab;
